module.exports = __webpack_public_path__ + "static/media/catandbookandexam.d61fab8d.gif";